import { Alert, Flex, IconButton } from '@chakra-ui/react';
import { FC, MouseEventHandler } from 'react';
import {
  IoInformationCircle,
  IoWarning,
  IoCheckmarkCircle,
  IoCloseCircle,
} from 'react-icons/io5';
import { IoClose } from 'react-icons/io5';

type AlertStatus = 'info' | 'warning' | 'success' | 'error';

const AlertComponent: FC<{
  isOpen: boolean;
  onClose: MouseEventHandler<HTMLButtonElement>;
  status: AlertStatus;
  title: string;
  description: string;
}> = ({ isOpen, onClose, status, title, description, ...props }) => {
  const getIcon = () => {
    switch (status) {
      case 'info':
        return <IoInformationCircle size="40px" />;
      case 'warning':
        return <IoWarning size="40px" />;
      case 'success':
        return <IoCheckmarkCircle size="40px" />;
      case 'error':
        return <IoCloseCircle size="40px" />;
      default:
        return <IoInformationCircle size="40px" />;
    }
  };

  return (
    <Alert.Root status={status} variant="subtle" hidden={!isOpen} {...props}>
      <Alert.Indicator mr={2}>{getIcon()}</Alert.Indicator>
      <Flex direction="column" m={2}>
        <Alert.Title fontSize="lg">{title}</Alert.Title>
        <Alert.Description maxWidth="sm">{description}</Alert.Description>
      </Flex>
      <IconButton
        onClick={onClose}
        variant="ghost"
        size="sm"
        aria-label="Close alert"
      >
        <IoClose size="20px" />
      </IconButton>
    </Alert.Root>
  );
};

export default AlertComponent;
